class TabComponent {
    constructor(){
        this.tablist = document.querySelector("#tablist")
        if (!this.tablist) return
        this.tabpanel = document.querySelectorAll(".tabpanel")
        this.addEvents()
    }

    addEvents(){
        this.tablist.addEventListener("click", (e) => {
            const button = e.target.closest("button")
            if (!button) return

            // If already active → stop
            if (button.dataset.state === "active") return

            // Remove active state from all buttons
            this.tablist.querySelectorAll("button").forEach(btn => {
                btn.dataset.state = "inactive"
            })

            // Set clicked button to active
            button.dataset.state = "active"

            // Send AJAX request
            this.loadTabContent(button.dataset.term)
        })
    }

    loadTabContent(selectedPanel){
        this.tabpanel.forEach(panel => {
            console.log("selectedPanel : ",selectedPanel)
            if (panel.dataset.term === selectedPanel) {
                panel.dataset.state = "active"
                panel.firstElementChild.classList.remove("hidden")
            } else {
                panel.dataset.state = "inactive"
                panel.firstElementChild.classList.add("hidden")
            }
        })
    }
}

export default TabComponent